import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, testClass } from 'omni-common-ui';

export class ExpansionGridItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  _onHeaderClick() {
    this.setState({ expanded: ! this.state.expanded });
  }

  _renderContent() {
    if (! this.state.expanded) {
      return null;
    }
    return <div className={styles.ExpansionGridItem_Content}>
      {this.props.children}
    </div>;
  }

  render() {
    const headerClassName = classnames(styles.ExpansionGridItem_header, testClass('expansion-item-header'), {
      [styles.__expanded]: this.state.expanded,
    });
    const iconClassName = classnames(styles.ExpansionGridItem_header_icon, {
      [styles.__expanded]: this.state.expanded,
    });
    return <div className={classnames(this.props.className, styles.ExpansionGridItem)}>
      <div className={headerClassName} onClick={() => this._onHeaderClick()}>
        <Icon id="chevron-small-right"
            className={iconClassName} />
        <span className={styles.ExpansionGridItem_header_title}>
          {this.props.title}
        </span>
        <span className={styles.ExpansionGridItem_header_summary}>
          {this.props.summary}
        </span>
      </div>
      {this._renderContent()}
    </div>;
  }
}

ExpansionGridItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string,
  children: PropTypes.node,
};

export default ExpansionGridItem;



// WEBPACK FOOTER //
// ./components/ExpansionGridItem/index.jsx